<template>
<li>
    <div class="message-reply">
        <img v-on:click="openPersonCard" v-bind:src="pictureUrl">
        <span class="reply-username">
            <span v-on:click="openPersonCard">{{person.firstName}} {{person.lastName}}</span>
        </span>
        <p class="reply-text">{{reply.comment}}</p>
    </div>
</li>
</template>

<script>

import {LeadBus} from '../../router/index';

export default {
    props: {
        reply: {},
        person: {}
    },

    computed: {
        pictureUrl() {
            return this.person && this.person.pictureUrl && this.person.pictureUrl !== '' ? this.person.pictureUrl : '/static/img/anonymous.svg';
        }
    },

    methods: {
        openPersonCard() {
            this.$emit('openPersonCard', this.person);
            LeadBus.$emit('recordLead', {
                type: 'attendee-profile-card',
                data: {
                    profileCardOf: this.person.id
                }
            });
        }
    }
};
</script>

<style lang="scss">

li {
    list-style-type: none;

    .message-reply {
        font-family: "Poppins", sans-serif;
        background-color:#242424;
        width: 100%;
        width: 75vw;
        margin-top:5px;

        img {
            margin-top:0px;
            position:absolute;
            height:24px;
            width:24px;
            cursor: pointer;
        }
        .reply-username {
            margin-left:35px;
            color: #d4451d;
            font-size: 1em;
            font-weight: 600;
            cursor: pointer;
        }
        .reply-text {
            margin-left:35px;
            padding-bottom:5px;
            overflow-wrap: break-word;
            margin-bottom: 1px;
            margin-top: 3px;
            margin-right: 20px;
            font-size: 1em;
            line-height: 1.2em;
        }
    }
}

</style>



// WEBPACK FOOTER //
// QuestionReplyBox.vue?42bf5960